/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dropwinnerssenttoast3Inputs */

const en_dropwinnerssenttoast3 = /** @type {(inputs: Dropwinnerssenttoast3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Winner message sent (${i?.count})`)
};

const de_dropwinnerssenttoast3 = /** @type {(inputs: Dropwinnerssenttoast3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gewinner-Nachricht gesendet (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Winner message sent ({count})" |
*
* @param {Dropwinnerssenttoast3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnerssenttoast3 = /** @type {((inputs: Dropwinnerssenttoast3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnerssenttoast3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnerssenttoast3(inputs)
	return de_dropwinnerssenttoast3(inputs)
});
export { dropwinnerssenttoast3 as "dropWinnersSentToast" }